import React from 'react';
import About from '../components/About';

const AboutPage: React.FC = () => {
  return (
    <div className="pt-20 sm:pt-24">
      <About />
    </div>
  );
};

export default AboutPage;
